var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08611 7.64722C6.02222 8.22222 6.83333 8.98333 7.46944 9.88333C7.66389 10.1583 7.84167 10.4472 8 10.7444C8.15833 10.4444 8.33611 10.1583 8.53056 9.88333C9.16667 8.98333 9.97778 8.22222 10.9139 7.64722C12.1556 6.88333 13.6139 6.44444 15.1667 6.44444H15.4417C15.75 6.44444 16 6.69444 16 7.00278C16 11.1139 12.6694 14.4444 8.55833 14.4444H8H7.44167C3.33056 14.4444 0 11.1139 0 7.00278C0 6.69444 0.25 6.44444 0.558333 6.44444H0.833333C2.38611 6.44444 3.84444 6.88333 5.08611 7.64722ZM8.375 2.15556C8.81111 2.625 10.0722 4.15 10.7194 6.72778C9.66389 7.32778 8.73611 8.13889 8 9.10556C7.26389 8.13889 6.33611 7.33056 5.28056 6.72778C5.925 4.15 7.18611 2.625 7.625 2.15556C7.72222 2.05278 7.85833 2 8 2C8.14167 2 8.27778 2.05278 8.375 2.15556Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.6116e13b65eff37ea8753976a83f1a8b.svg";
export { ForwardRef as ReactComponent };